import makeTriggerSpine from 'core/display/context/animation/TriggerSpine'
import { signal } from 'services/SignalsService'
import { delay } from 'utils/Delay'
import { create } from 'utils/Object'

export default class BookFsReel extends PIXI.Container{
  constructor(data) {
    super()
    const reelAnimation = { spine: 'animations/spine/freespins/reels/skeleton.json' }
    const reel = new makeTriggerSpine(create(data, reelAnimation))
    let isStopped

    signal.on('RESIZE', () => {
      isStopped && signal.dispatch('PLATFORM-STOP')
    })

    signal.on('ACTION:FS-START', () => {
      this.addChild(reel)
      isStopped = false
    })

    signal.on('BUTTON:startFreespin',  async () => {
      isStopped = true
      await delay(1.8)
      signal.dispatch('END-REEL-ANIMATION')
    })

    signal.on('INIT:FREESPINS',  () => {
      this.addChild(reel)
      isStopped = true
    })

    signal.on('STATE:IN:FS-END', () => {
      isStopped = false
    })
  }
}
